<template>
  <div class="container">
    <!-- Logo 和标题 -->
    <div class="logo-container">
      <!-- <div class="octagon">
        <div class="square1"></div>
        <div class="square2"></div>
      </div>
      <div class="text">中国建材</div> -->
      <div class="logo">
        <img src="../assets/logo.png" alt="" />
      </div>
    </div>
    <!-- <div class="btns">
      <div class="closeCouplet" @click="closeCouplet(1)" v-if="show">
        关闭对联
      </div>
      <div class="closeCouplet" @click="closeCouplet(0)" v-else>打开对联</div>
      <div class="to-old" @click="toOld">登陆旧版</div>
      <div class="help" @click="help">帮助</div>
    </div> -->
    <div class="sys-title">地勘中心<br />安全生产智能管理平台</div>
    <!-- 搜索框 -->
    <div class="search-container">
      <el-select
        class="search-input"
        v-model="searchText"
        placeholder="输入公司名称查询"
        clearable
        filterable>
        <el-option
          v-for="item in selectData"
          :key="item.url"
          :label="item.text"
          :value="item.url">
        </el-option>
      </el-select>
      <el-button
        type="primary"
        @click="navigateTo(searchText)"
        class="search-button"
        >进入</el-button
      >
    </div>

    <!-- 分类内容 -->
    <div class="categories">
      <div class="category">
        <div class="boss-container">
          <el-button class="boss" @click="navigateTo('zxaq.nonmine.cn')"
            >中国建筑材料工业地质勘查中心</el-button
          >
          <!-- 新增架构图的连线部分 -->
          <div class="line-container">
            <!-- 横向连线 -->
            <div class="horizontal-line"></div>
            <!-- 左纵向连线1 -->
            <div class="vertical-line vertical-line-left1"></div>
            <!-- 左纵向连线2 -->
            <div class="vertical-line vertical-line-left2"></div>
            <!-- 左纵向连线3 -->
            <div class="vertical-line vertical-line-left3"></div>
            <!-- 中间纵向连线 -->
            <div class="vertical-line vertical-line-center"></div>
            <!-- 右纵向连线1-->
            <div class="vertical-line vertical-line-right1"></div>
            <!-- 右纵向连线2 -->
            <div class="vertical-line vertical-line-right2"></div>
            <!-- 右纵向连线3 -->
            <div class="vertical-line vertical-line-right3"></div>
          </div>
        </div>
        <div class="links">
          <el-button
            v-for="link in links"
            :key="link.text"
            class="link-button"
            type="text"
            @click="navigateTo(link.url)"
            style="margin: 0">
            {{ link.text }}
          </el-button>
        </div>
      </div>
    </div>

    <div class="footer">
      <Footer />
    </div>
    <!-- <el-dialog :visible.sync="dialogVisible" width="60%">
      <NaviHelp></NaviHelp>
    </el-dialog> -->
  </div>
</template>

<script>
import Footer from "./FooterIndex.vue";
// import NaviHelp from "./NaviHelp.vue";
export default {
  data() {
    return {
      show: true,
      searchText: "",
      links: [
        // { text: "中国建筑材料工业地质勘查中心", url: "zxaq.nonmine.cn" },
        { text: "资环公司", url: "zjczh.nonmine.cn" },
        { text: "中材地勘院", url: "zcdky.nonmine.cn" },
        {
          text: "河北总队",
          url: "hebzd.nonmine.cn",
        },
        {
          text: "山西总队",
          url: "sxzd.nonmine.cn",
        },
        {
          text: "内蒙古总队",
          url: "nmgzd.nonmine.cn",
        },
        {
          text: "辽宁总队",
          url: "lnzd.nonmine.cn",
        },
        {
          text: "吉林总队",
          url: "jlzd.nonmine.cn",
        },
        {
          text: "黑龙江总队",
          url: "hljzd.nonmine.cn",
        },
        {
          text: "江苏总队",
          url: "jszd.nonmine.cn",
        },
        {
          text: "浙江总队",
          url: "zjzd.nonmine.cn",
        },
        {
          text: "安徽总队",
          url: "ahzd.nonmine.cn",
        },
        {
          text: "福建总队",
          url: "fjzd.nonmine.cn",
        },
        {
          text: "江西总队",
          url: "jxzd.nonmine.cn",
        },
        {
          text: "山东总队",
          url: "sdzd.nonmine.cn",
        },
        {
          text: "河南总队",
          url: "henzd.nonmine.cn",
        },
        {
          text: "湖北总队",
          url: "hubzd.nonmine.cn",
        },
        {
          text: "湖南总队",
          url: "hunzd.nonmine.cn",
        },
        {
          text: "广东总队",
          url: "gdzd.nonmine.cn",
        },
        {
          text: "广西总队",
          url: "gxzd.nonmine.cn",
        },
        {
          text: "四川总队",
          url: "sczd.nonmine.cn",
        },
        {
          text: "贵州总队",
          url: "gzzd.nonmine.cn",
        },
        {
          text: "云南总队",
          url: "ynzd.nonmine.cn",
        },
        {
          text: "陕西总队",
          url: "shzd.nonmine.cn",
        },
        {
          text: "甘肃总队",
          url: "gszd.nonmine.cn",
        },
        {
          text: "青海总队",
          url: "qhzd.nonmine.cn",
        },
        {
          text: "宁夏总队",
          url: "nxzd.nonmine.cn",
        },
        {
          text: "新疆总队",
          url: "xjzd.nonmine.cn",
        },
        { text: "高岭土", url: "zgglt.nonmine.cn" },
        { text: "咸阳非矿院", url: "xyy.nonmine.cn" },
        { text: "新疆膨润土", url: "xjprt.nonmine.cn" },
        // { text: "江西中非矿物材料有限公司", url: "jxgs.nonmine.cn" },
      ],
      selectData: [],
      dialogVisible: null,
    };
  },
  components: {
    Footer,
    // NaviHelp,
  },
  created() {
    // const checkbox = localStorage.getItem("checkbox");
    // if (checkbox && checkbox === "true") {
    //   this.dialogVisible = false;
    // } else {
    //   this.dialogVisible = true;
    // }

    this.selectData = [
      {
        text: "中国建筑材料工业地质勘查中心",
        url: "zxaq.nonmine.cn",
      },
      ...this.links,
    ];
  },
  methods: {
    navigateTo(url) {
      if (url) {
        window.open(`http://${url}/dksafe/`, "_blank");
      } else {
        this.$message({
          message: "请先选择公司",
          type: "warning",
        });
      }
    },
    //返回旧版
    toOld() {
      window.open("http://anquan.nonmine.cn", "_blank");
    },
    //
    help() {
      this.dialogVisible = true;
    },
    closeCouplet(val) {
      this.show = !this.show;
      this.$emit("closeCouplet", val);
    },
  },
};
</script>

<style scoped>
/* 主容器样式 */
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
  /* margin-top: 40px; */
  padding-top: 130px;
  padding-bottom: 20px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
}
/* Logo 和标题样式 */
.logo-container {
  position: absolute;
  top: 8%;
  left: 8%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
}
.text {
  margin-left: 10px;
  font-weight: 900;
  font-size: 30px;
  color: #d7171f;
  font-family: "黑体";
}
.logo img {
  width: 20%;
  height: auto;
  object-fit: contain;
}
.title {
  margin-top: 10px;
  font-size: 24px;
  color: #fff;
}

/* 搜索框样式 */
.search-container {
  margin: 20px 0;
}
.search-input {
  width: 700px;
}

/* 分类标题和链接样式 */
.categories {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 80px;
}
.category {
  flex: 1 1 30%;
  margin: 10px;
}
.category-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}
.links {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
}
.link-button {
  flex: 0 0 calc(16.666% - 20px); /* 每个按钮占一行的三分之一，减去间距 */
  max-width: calc(16.666% - 20px); /* 保证宽度不超出容器 */
  padding: 11px 20px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border: none;
  background: linear-gradient(
    0deg,
    rgba(17, 67, 83, 0.8) 0%,
    rgba(78, 188, 218, 0.8) 100%
  );
}

.link-button:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
  /* color: #00397c; */
}
.octagon {
  position: relative;
  width: 50px;
  height: 50px;
  background-color: #d7171f;
  clip-path: polygon(
    30% 0%,
    70% 0%,
    100% 30%,
    100% 70%,
    70% 100%,
    30% 100%,
    0% 70%,
    0% 30%
  );
  display: flex;
  align-items: center;
  justify-content: center;

  /* 整体旋转+缩放 */
  animation: spin-scale 6s linear infinite;
}

.square1 {
  position: absolute;
  width: 20px;
  height: 20px;
  background: #00161a;

  /* 外层正方形延迟旋转 */
  animation: square-spin 6s linear infinite;
}

.square2 {
  position: absolute;
  width: 20px;
  height: 20px;
  background: #00161a;
  transform: rotate(45deg);

  /* 内层正方形反向旋转 */
  animation: square-spin-reverse 6s linear infinite;
}
.boss {
  flex: 0 0 calc(33.333% - 20px); /* 每个按钮占一行的三分之一，减去间距 */
  width: calc(33.333% - 20px); /* 保证宽度不超出容器 */
  padding: 16px 30px;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  /* background: linear-gradient(
    0deg,
    rgba(17, 67, 83, 0.8) 0%,
    rgba(78, 188, 218, 0.8) 100%
  ); */
  background: linear-gradient(90deg, #243949 0%, #517fa4 100%);
  border: none;
}
.boss:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.line-container {
  position: relative;
  width: 100%;
  height: 80px;
  margin: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 横向连线样式 */
.horizontal-line {
  position: absolute;
  top: 50%;
  width: 84%;
  height: 2px;
  background-color: #fff;
  z-index: 1;
}
.vertical-line-left1 {
  position: absolute;
  top: 50%;
  left: 8%;
  width: 2px;
  height: 50px;
  background-color: #fff;
}

/* 左侧纵向连线样式 */
.vertical-line-left2 {
  position: absolute;
  top: 50%;
  left: 25%;
  width: 2px;
  height: 50px;
  background-color: #fff;
}
.vertical-line-left3 {
  position: absolute;
  top: 50%;
  left: 42%;
  width: 2px;
  height: 50px;
  background-color: #fff;
}
/* 中间纵向连线样式 */
.vertical-line-center {
  position: absolute;
  top: -10%;
  left: 50%;
  transform: translateX(-50%);
  width: 5px;
  height: 50px;
  background-color: #fff;
}

.vertical-line-right1 {
  position: absolute;
  top: 50%;
  right: 8%;
  width: 2px;
  height: 50px;
  background-color: #fff;
}
/* 右侧纵向连线样式 */
.vertical-line-right2 {
  position: absolute;
  top: 50%;
  right: 25%;
  width: 2px;
  height: 50px;
  background-color: #fff;
}
.vertical-line-right3 {
  position: absolute;
  top: 50%;
  right: 42%;
  width: 2px;
  height: 50px;
  background-color: #fff;
}
.footer {
  position: fixed;
  right: 0%;
  bottom: 0%;
  width: 100%;
}
.search-button {
  background-color: #206174;
  border: 1px solid #206174;
}
.search-button :hover {
  background-color: #60adc4;
  color: #00397c;
}

.sys-title {
  color: #fff;
  font-weight: 600;
  font-size: 30px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
}
/* .to-old {
  position: fixed;
  top: 1%;
  right: 4%;
  color: #fff;
  font-size: 16px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    color: #66b1ff;
  }
}
.help {
  position: fixed;
  top: 1%;
  right: 1%;
  color: #fff;
  font-size: 16px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    color: #66b1ff;
  }
} */
.btns {
  display: flex;
  position: fixed;
  top: 1%;
  right: 0%;
  color: #fff;
  font-size: 16px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
  cursor: pointer;
  text-decoration: underline;
}
.btns > * {
  margin-right: 15px;
}
.btns > *:hover {
  color: #66b1ff;
}
</style>
